'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../styleInject.js');

var css_248z = ".Tag-module_tagRoot__CrM0b{position:relative;width:100%}.Tag-module_tagContent__JfuBl{align-items:center;background-color:#000;border-radius:4px 0 3px;color:#fff;display:flex;flex-direction:row;font-size:12px;justify-content:center;padding:4px 8px;position:absolute}";
var styles = {"tagRoot":"Tag-module_tagRoot__CrM0b","tagContent":"Tag-module_tagContent__JfuBl"};
styleInject["default"](css_248z, '280a0072-ca51-4f9f-90bc-d60edae39bee');

exports["default"] = styles;
